import { BaseApi } from '@/main/baseApi';
import { NdPrijemkaPolozky } from '@/modules/sklad/ndPrijemka/polozky';

import { DependentTableNames, DOKLADY, EDL, MODULE_API, NAME, PR_ORDER } from './constants';

export const prijemkaTiskUrl = '/Reports/Reports/GetPrijemkaNdReport';
export const goodReceivedNoteReportUrl = '/Reports/Reports/GetGoodReceivedReport';
export const partsPurInvoiceUrl = '/Servis/Reports/GetPartsPurchaseInvoiceReport';

class NdPrijemkaProvider extends BaseApi {
	edl(file: any) {
		return this.uploadMultipart(`/${MODULE_API}/${NAME}/${EDL}Rows`, file);
	}

	insertEdlPolozky(NdPrijemkaPolozkyDTOs: object[]) {
		const promises = NdPrijemkaPolozkyDTOs.map((polozka) => this.post(`/${MODULE_API}/${NdPrijemkaPolozky.name}`, polozka));
		return Promise.all(promises);
	}

	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case NdPrijemkaPolozky.name:
				return `/${this.area}/${NdPrijemkaPolozky.name}/Schema`;
			case DOKLADY:
				return `/${this.area}/${NAME}/${DOKLADY}Schema`;
			case PR_ORDER:
				return `/${this.area}/${PR_ORDER}/SelectSchema`;
			default:
				throw new Error(`schema for ${tableName} is not implemented yet`);
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case NdPrijemkaPolozky.name:
				return `/${this.area}/${NdPrijemkaPolozky.name}/`;
			case DOKLADY:
				return `/${this.area}/${NAME}/${DOKLADY}Rows`;
			case PR_ORDER:
				return `/${this.area}/${PR_ORDER}/SelectRows`;
			default:
				throw new Error(`data for ${tableName} is not implemented yet`);
		}
	}
	
	edl2NdPrijemka(edlId: number) {
		return this.post(`/${MODULE_API}/${NAME}/Edl2NdPrijemka?edlId=${edlId}`);
	}

	savePrReceiptItems(prReceiptData: object) {
		return this.post(`/${MODULE_API}/${NAME}/SavePRreceipt`, prReceiptData);
	}

	updateLeftToDeliverCount(mioId: number, leftToDeliverCount: number) {
		return this.fetch(`/${MODULE_API}/${NAME}/UpdateleftToDeliverCount`, { mioId, leftToDeliverCount });
	}

	updatePurchaseOrderItemsCount(prijemkaId: number) {
		return this.fetch(`/${MODULE_API}/${NAME}/UpdatePurchaseOrderItemsCount`, { prijemkaId });
	}

	generateInvoice(filter: any) {
		return this.post(`/${MODULE_API}/${NAME}/GenerateInvoice`, filter);
	}

	autoClosePrOrder(id: number) {
		return this.post(`/${MODULE_API}/${NAME}/AutoClosePrOrder?PrijemkaId=${id}`);
	}

	cancelPrReceipt(filter: any) {
		return this.fetch(`/${MODULE_API}/${NAME}/CancelPrReceipt`, filter);
	}

	getSPCPValidation(prijemkaId: number) {
		return this.fetch(`/${MODULE_API}/${NAME}/GetSPCPValidation`, { prijemkaId });
	}

	updateMioCountAfterpartDelete(zaznamId: number) {
		return this.fetch(`/${MODULE_API}/${NAME}/UpdateMioCountAfterpartDelete`, { zaznamId });
	}

	updateNdPrijemkaAfterDelete(zaznamId: number) {
		return this.fetch(`/${MODULE_API}/${NAME}/UpdateNdPrijemkaAfterDelete`, { zaznamId });
	}

	updateMioCount(prorderId: number) {
		return this.fetch(`/${MODULE_API}/${NAME}/UpdateMioCount`, { prorderId });
	}

	async getTotalCount(prijmekaId: number) {
		return this.fetch(`/${MODULE_API}/${NAME}/GetTotalCount?PrijemkaId=${prijmekaId}`);
	}

	markReportAsPrinted(Id: number | null, reportType: string | null) {
		return this.post(`/Servis/Zakazka/MarkAsPrint?id=${Id}&reportType=${reportType}`);
	}
	saveGrnItems(grnItems: object, prijemkaId:number|null) {
		return this.post(`/${MODULE_API}/${NAME}/ManageGrnItems?ndprijemkaId=${prijemkaId}&grnItems=`,grnItems);
	}

	saveMultiplePRreceipt(prReceiptData: object) {
		return this.post(`/${MODULE_API}/${NAME}/SaveMultiplePRreceipt?prReceiptData=`, prReceiptData);
	}

	processPartsReceiptFile() {
		return this.fetch(`/${MODULE_API}/${NAME}/ProcessPartsReceiptFile?prReceiptData=`);
	}

	isPRReceiptDeleteEligible(prReceiptId: number | null) {
		return this.fetch(`/${MODULE_API}/${NAME}/IsPRReceiptDeleteEligible?prReceiptId=${prReceiptId}`);
	}

}
export const apiProvider = new NdPrijemkaProvider(MODULE_API, NAME);
